module.exports = __webpack_public_path__ + "fonts/creditu-icons.ef4d8d69.woff";